import React, { useState } from "react";
import MultiStepForm from "../../DataEntry/MultiStepForm";
import ApplicantForm from "./Applicant";
import ApplicantFinancial from "./Financial";
import { getEmptyVoucher } from "./Model";
import PreQualForm from "./PreQual";
import FinalPreview from "./Preview";
import { MultiFormContext } from "../../DataEntry/MultiFormContext";
import Payment from "./Payment";

const create_steps = [
  "Prequalification",
  "Applicant Info",
  "Financial Info",
  "Review",
];

const modify_steps = [
  "Financial Info",
  "Review",
];

const MainForm = ({ individualApplication, onExit, onClose, voucherInitialValues, createMode = true }) => {

  const [paymentInfo, setPaymentInfo] = useState({ paymentRequired: false, paymentUrl: "", applicationModified: false });
  const [formCompleted, setFormCompleted] = React.useState(false);

  return (
    <React.Fragment>
      {!formCompleted && createMode &&
        <MultiStepForm
          title="Create Voucher Application"
          steps={create_steps}
          initialValues={voucherInitialValues}
          showLogo={individualApplication}
          onClose={onClose}
          lastStepButtonLabel="Save Application and Continue to Payment"

        >
          {(step, page, formProps) => {
            switch (step) {
              case 0:
                return <MultiFormContext.Consumer>
                  {value => <PreQualForm page={page} formProps={formProps} multiStepState={value} />}
                </MultiFormContext.Consumer>
              case 1:
                return <ApplicantForm page={page} formProps={formProps} />;
              case 2:
                return <ApplicantFinancial page={page} formProps={formProps} />;
              default:
                return <FinalPreview page={page} formProps={formProps} onExit={(paymentRequired, paymentUrl, applicationModified) => {
                  setFormCompleted(true);
                  setPaymentInfo({ paymentRequired, paymentUrl, applicationModified });
                }} />;
            }
          }}
        </MultiStepForm>
      }

      {!formCompleted && !createMode &&
        <MultiStepForm
          title="Update Voucher Application"
          steps={modify_steps}
          initialValues={voucherInitialValues}
          showLogo={individualApplication}
          onClose={onClose}
          lastStepButtonLabel="Save Application and Continue to Payment"

        >
          {(step, page, formProps) => {
            switch (step) {
              case 0:
                return <ApplicantFinancial page={page} formProps={formProps} />;
              default:
                return <FinalPreview page={page} formProps={formProps} onExit={(paymentRequired, paymentUrl, applicationModified) => {
                  setFormCompleted(true);
                  setPaymentInfo({ paymentRequired, paymentUrl, applicationModified });
                }} />;
            }
          }}
        </MultiStepForm>
      }      
      {formCompleted &&
        <Payment
        paymentRequired={paymentInfo.paymentRequired}
        paymentUrl={paymentInfo.paymentUrl}
        applicationModified={paymentInfo.applicationModified}
        onExit={onExit} />
      }
    </React.Fragment>
  );
};

export default MainForm;